import React, { useMemo } from 'react'
import FormControlLabel from '@mui/material/FormControlLabel'
import MuiSwitch from '@mui/material/Switch'
import FormHelperText from '@mui/material/FormHelperText'
import ErrorMessage from '../../ErrorMessage'
import { InputFieldBase } from '../types'
import { FieldType } from '../../utils/fieldTypeEnum'
import { useController } from 'react-hook-form'

type SwitchProps = InputFieldBase & {}

export const Switch: React.FC<SwitchProps> = ({ label, required, disabled, fieldType, control, ...props }) => {
  if (fieldType != FieldType.SWITCH) throw Error(`Switch field expected fieldtype of SWITCH, instead got ${fieldType}`)
  const fieldName = props.name!
  const { field, fieldState } = useController({ name: fieldName, control, rules: { required: required! } })
  const hasError = Boolean(fieldState.error)

  const styles = useMemo(
    () => ({
      formControlLabel: {
        paddingBottom: '18px', //combined with padding from checkbox for ~24px
        marginLeft: 0,
        '& > span:first-child': {
          alignSelf: 'baseline',
        },
        '& > span': {
          '& > p': {
            margin: '8px 0px 14px 0px',
            textAlign: 'start',
          },
        },
      },
      formControlLabelWithError: {
        paddingBottom: 0,
        marginLeft: 0,
        '& > span:first-child': {
          alignSelf: 'baseline',
        },
        '& > span': {
          '& > p': {
            margin: '8px 0px 14px 0px',
            textAlign: 'start',
          },
        },
      },
      errorLabel: {
        margin: '8px 0 0 0',
        paddingBottom: '24px',
      },
    }),
    [],
  )

  return (
    <div>
      <FormControlLabel
        sx={hasError ? styles.formControlLabelWithError : styles.formControlLabel}
        control={
          <MuiSwitch {...props} {...field} checked={Boolean(field.value)} disabled={disabled!} required={required!} />
        }
        label={label}
      />
      {required && hasError && (
        <FormHelperText error variant="standard" sx={styles.errorLabel}>
          <ErrorMessage>
            <>{fieldState.error?.message}</>
          </ErrorMessage>
        </FormHelperText>
      )}
    </div>
  )
}
